import styled from "styled-components";
import { string, func } from "prop-types";
import { Button } from "../Button";
export const Quotes = (props) => {
  return (
    <Wrapper>
      <Quote>{props.quote}</Quote>
      <Speaker> {props.speaker}</Speaker>
      <Button onClick={props.onUpdate}>New Quote</Button>
    </Wrapper>
  );
};
Quotes.propTypes = {
  quote: string,
  speaker: string,
  onUpdate: func,
};
const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50vw;
  @media (max-width: 768px) {
  
  }
`;
const Quote = styled.p`
  font-size: 2em;
  margin: 0;
  position: absolute;
  top: 35vh;
  width: 50vw;
  @media (max-width: 768px) {
    font-size: .7em;
    top: 45vh; 
  }
`;
const Speaker = styled(Quote)`
  position: absolute;
  top: 53vh;
  margin: 30px;
`;
